export default __webpack_public_path__ + "static/media/rhb-icon.7775e074.svg";